import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Checkmark from '@hellodarwin/icons/dist/icons/Check';
import { useTheme } from 'styled-components';
import { LineItemContainer } from '../styles';
const ShowCaseListItem = ({ children }) => {
    const theme = useTheme();
    return (_jsxs(LineItemContainer, { children: [_jsx("div", { style: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    height: theme.fontsLineHeights.body1,
                }, children: _jsx(Checkmark, { size: 20 }) }), _jsx(Typography, { elementTheme: "body1", children: children })] }));
};
export default ShowCaseListItem;
